const years = new Array(10);
const now = new Date();
for (let i = 0; i < years.length; i++) {
  years[i] = now.getFullYear() + i;
}

const CALCULATE_NEEDED = "CALCULATE_NEEDED";
const START_OVER = "START_OVER";
const UPDATE_FORM = "UPDATE_FORM";
const TEST_CALCULATOR_DATA = "TEST_CALCULATOR_DATA";
const TEST_USER_DATA = "TEST_USER_DATA";
const SET_BIRTHDAY1 = "SET_BIRTHDAY1";
const SET_BIRTHDAY2 = "SET_BIRTHDAY2";
const SET_AGE1 = "SET_AGE1";
const SET_AGE2 = "SET_AGE2";
const SET_TOTALINCOME = "SET_TOTALINCOME";
const SET_NON401IRAINCOME = "SET_NON401IRAINCOME";
const SET_CURRENTPROPERTY = "SET_CURRENTPROPERTY";
const GENERATE_BUDGET = "GENERATE_BUDGET";
const GENERATE_WAGE_ARRAY = "GENERATE_WAGE_ARRAY";
const GENERATE_SS_ARRAY = "GENERATE_SS_ARRAY";
const GENERATE_PVT_ARRAY = "GENERATE_PVT_ARRAY";
const GENERATE_PUBLIC_ARRAY = "GENERATE_PUBLIC_ARRAY";
const SET_INVESTMENT_INCOME = "SET_INVESTMENT_INCOME";
const GENERATE_SHORTFALL = "GENERATE_SHORTFALL";
const GENERATE_YEARS = "GENERATE_YEARS";
const SET_MARRIED_INCOME = "SET_MARRIED_INCOME";
const FETCH_PROFILE = "FETCH_PROFILE";
const FETCH_BASE_PROPERTY = "FETCH_BASE_PROPERTY";

const initState = {
  both: true,
  tenYear: [],
  tenYearBase: [],
  federalTaxes: [],
  stateTaxes: [],
  activeYearIndex: 0,
  healthInsurance: true,
  id: "",
  phone: "",
  subjectS1: "",
  numSubS1: "",
  taxFileS1: "",
  justWagesS1: false,
  targetTaxableBudgetS1: "",
  birthdayS1: "",
  birthYearS1: "",
  ageS1: "",
  ageIndex: 0,
  marriedAgeIndex: 0,
  startAge: "",
  ageWagesStopS1: "",
  retireYearS1: "",
  stashedRetireAgeS1: "",
  retireAgeS1: "",
  non401IraIncome: "",
  planYearS1: "",
  ageYearS1: "",
  wagesS1: "",
  socialSecurityS1: "",
  pvtPensionS1: "",
  pvtPensionAgeS1: "",
  pubPensionS1: "",
  pubPensionAgeS1: "",
  k401AnnuityS1: "",
  k401S1: "",
  k401AgeS1: "",
  iraAgeS1: "",
  iraS1: "",
  iraAnnuityS1: "",
  annuityS1: "",
  healthInsS1: "",
  ageGroupS1: "",

  birthdayS2: "",
  ageWagesStopS2: "",
  retireAgeS2: "",
  wagesS2: "",
  socialSecurityS2: "",
  pvtPensionS2: "",
  pvtPensionAgeS2: "",
  pubPensionS2: "",
  pubPensionAgeS2: "",
  k401S2: "",
  k401AgeS2: "",
  iraS2: "",
  iraAgeS2: "",
  annuityS2: "",
  k401AnnuityS2: "",
  iraAnnuityS2: "",

  activePropertyObject: {
    AnnualSaveCompToBase: null,
    EstAnnualStateLocalIncomeTax: null,
    EstimatedYearlyCost: null,
    HOA: 0,
    HOAIndex: 1,
    HealthInsIndex: 1,
    HealthInsurance: 0,
    HomeInsIndex: 1,
    HomeInsurance: 0,
    ModelIndex: 1,
    PNIindex: 4,
    PlanYear: 0,
    PrincipalNInterest: 0,
    PropTaxIndex: 0,
    PropertyTax: 0,
    SnLocTaxIndex: 0,
  },
  activeStateTaxObject: {
    AGI: "0",
    Base: "0",
    Blo: 0,
    BracketRank: 6,
    FedTaxLine11b: "0",
    FederalTax: "0",
    FileSubject: "S1",
    NumSub: 2,
    PlanYear: 2022,
    SSYr: "N",
    StateCode: "CA",
    StateIncome: "0",
    StateTax: 0,
    StateTaxableIncome: "0",
    TaxFile: "S",
    TaxRate: 0.093,
    TaxRule: "2",
    TotalIncomeL7b: "0",
  },
  activeFederalTaxObject: {
    AGI: "0",
    Age2: null,
    Annuity: "0.0000",
    CapGain: "0.0000",
    FICA: "0.0000",
    FedTaxYr: 2019,
    FederalTax: "0",
    FileSubject: "S1",
    K401: "0",
    Line9SS: "0",
    MedicareTax: "0.0000",
    NumSub: 2,
    OldestAge: 69,
    OrdinaryDividends: "0.0000",
    OtherIncome: "0.0000",
    PlanYear: 2031,
    PubPension: "0",
    PvtPension: "0",
    RecordTStamp: "2020-07-05 14:33:50",
    SSTax: "0.0000",
    SocialSecurity: "0",
    StandardDeduction: "0",
    TaxFile: "S",
    TaxableIRA: "0.0000",
    TaxableIncome: "0",
    TaxableInterest: "0.0000",
    TaxablePensionAnnuity401K: "0",
    TaxableSocialSecurity: "0",
    TotalIncomeL7b: "0",
    Wages: "0.0000",
  },

  // injecting boilerplate years below

  totalIncome: "",
  totalInvestmentIncome: "",
  baseProperty: {},
  properties: [],
  mockProperties: [
    {
      position: [36.3, -93.53],
      color: "blue",
      street: "Broadway Street",
      city: "Berryville",
      statecode: "AR",
      zip: "72616",
      lat: "3.631677900000000e+001",
      lng: "-9.356160000000000e+001",
      geoschooldist: "Berryville Public Schools",
      sqft: "1356",
      _id: "3",
      currentprice: "$245,000",
      principalninterest: "$1,777",
      hoa: "$0",
      monthlyproptaxbill: "$151",
      insurance: "$69",
      healthInsuranceDesc: "(2nd cheapest Silver)",
      healthInsurance: "$2,004",
      incomeTax: "$0",
      yearlyCost: "$40,904",
      baseSavings: "$4,669",
      built: "1994",
      bedrooms: "2",
      bath: "1.5",
    },
    {
      position: [44.9, -93.23],
      color: "blue",
      street: "Main Street",
      city: "Minneapolis",
      statecode: "MN",
      zip: "72616",
      lat: "4.631677900000000e+001",
      lng: "-15.356160000000000e+001",
      geoschooldist: "MN Public Schools",
      sqft: "1950",
      _id: "4",
      currentprice: "$395,000",
      principalninterest: "$1,777",
      hoa: "$0",
      monthlyproptaxbill: "$151",
      insurance: "$69",
      healthInsuranceDesc: "(2nd cheapest Silver)",
      healthInsurance: "$2,004",
      incomeTax: "$0",
      yearlyCost: "$40,904",
      baseSavings: "$4,669",
      built: "1994",
      bedrooms: "2",
      bath: "1.5",
    },
    {
      position: [41.2, -95.93],
      color: "blue",
      street: "Buffet Avenue",
      city: "Omaha",
      statecode: "NE",
      zip: "72616",
      lat: "4.631677900000000e+001",
      lng: "-15.356160000000000e+001",
      geoschooldist: "Omaha Public Schools",
      sqft: "2850",
      _id: "5",
      currentprice: "$346,000",
      principalninterest: "$1,777",
      hoa: "$0",
      monthlyproptaxbill: "$151",
      insurance: "$69",
      healthInsuranceDesc: "(2nd cheapest Silver)",
      healthInsurance: "$1700",
      incomeTax: "$0",
      yearlyCost: "$40,904",
      baseSavings: "$4,669",
      built: "1994",
      bedrooms: "2",
      bath: "1.5",
    },
  ],
  currentProperty: {
    prop_id: 0,
  },
  currentMortgagePayment: "",
  markers: [],
  user_token: "",
  homeLat: "",
  homeLng: "",
  currentStreetAddress: "",
  currentCityAddress: "",
  currentStateAddress: "",
  currentZipAddress: "",
  firstName: "",
  lastName: "",
  userAgreement: "",
  subscriptionPeriod: "",
  userBAddress: "",
  homePayment: "",
  homeInsurance: "",
  propertyTax: "",
  lengthOfLoan: "",
  mortgageDownPayment: "",
  mortgageInterestRate: "",
  targetSavings: "",
  addlExpenses: "",
  secondHouse: false,
  county: "",
  europeanDataSubject: "no",
  schoolDistrict: "",
  recordTStamp: "",
  email: "",
  password: "",
  years: years,
  startingYear: 2020,
  budgetArray: [],
  ageArray: [],
  wageArray: [],
  ssArray: [],
  pvtArray: [],
  pubArray: [],
  non401IRAArray: [],

  totalIncomeArray: [],

  investmentIncomeArray: [],

  incomeNeededArray: [],

  annuityIncomeArray: [],

  ageGroupArrayS1: [],
  ageGroupArrayS2: [],

  marriedAgeArray: [],
  marriedWageArray: [],
  marriedSsArray: [],
  marriedPvtArray: [],
  marriedPubArray: [],
  marriedNon401IRAArray: [],
  marriedTotalIncomeArray: [],
  marriedInvestmentIncomeArray: [],
  marriedIncomeNeededArray: [],
  marriedAnnuityIncomeArray: [],
  actualInvestmentArray: [],
  marriedActualInvestmentArray: [],

  combinedWageArray: [],
};

function generateMockData() {
  return {
    ...initState,
    targetTaxableBudgetS1: "75000",
    // this needs to be changed to a plain year
    birthdayS1: "07-1962",
    ageWagesStopS1: "62",
    retireAgeS1: "62",
    wagesS1: "40000",
    socialSecurityS1: "20000",
    pvtPensionS1: "10000",
    pvtPensionAgeS1: "60",
    pubPensionS1: "10000",
    pubPensionAgeS1: "60",
    // technical
    k401S1: "10000",
    k401AgeS1: "60",

    annuityS1: "1000",
    k401AnnuityS1: "3000",
    iraAnnuityS1: "2000",

    birthdayS2: "03-1960",
    ageWagesStopS2: "60",
    retireAgeS2: "62",
    wagesS2: "30000",
    socialSecurityS2: "20000",
    pvtPensionS2: "10000",
    pvtPensionAgeS2: "60",
    pubPensionS2: "0",
    pubPensionAgeS2: "60",
    k401S2: "20000",
    k401AgeS2: "60",
    annuityS2: "1000",
    k401AnnuityS2: "3000",
    iraAnnuityS2: "2000",

    years,
    homePayment: "1000",
    currentStreetAddress: "",
    currentCityAddress: "",
    currentStateAddress: "",
    currentZipAddress: "",
    firstName: "",
    lastName: "",
    userAgreement: "yes",
    subscriptionPeriod: "5",
    email: "tavaner@tavaner.com",
    phone: "2068884545",
    confirmEmail: "tavaner@tavaner.com",

    password: "~123Afterwardz",
    confirmPassword: "~123Afterwardz",

    homePayment: "",
    homeInsurance: "",
    propertyTax: "",
    lengthOfLoan: "15",
    mortgageDownPayment: "0",
    mortgageInterestRate: "0",
    targetSavings: "0",
    addlExpenses: "0",
    // do we really want to record boolean values as strings?
    // secondHouse: "no",
    secondHouse: false,
    europeanDataSubject: "",
    schoolDistrict: "",
  };
}

function generateEmptyMockData() {
  return {
    ...initState,
    targetTaxableBudgetS1: "0",
    // this needs to be changed to a plain year
    birthdayS1: "07-1960",
    ageWagesStopS1: "62",
    retireAgeS1: "62",
    wagesS1: "0",
    socialSecurityS1: "0",
    pvtPensionS1: "0",
    pvtPensionAgeS1: "60",
    pubPensionS1: "0",
    pubPensionAgeS1: "60",
    // technical
    k401S1: "0",
    k401AgeS1: "60",
    iraS1: "0",
    iraAgeS1: "59",
    annuityS1: "0",
    k401AnnuityS1: "0",
    iraAnnuityS1: "0",
    totalInvestmentIncome: "0",

    birthdayS2: "03-1960",
    ageWagesStopS2: "60",
    retireAgeS2: "66",
    wagesS2: "0",
    socialSecurityS2: "0",
    pvtPensionS2: "0",
    pvtPensionAgeS2: "60",
    pubPensionS2: "0",
    pubPensionAgeS2: "60",
    k401S2: "0",
    k401AgeS2: "60",
    iraS2: "0",
    iraAgeS2: "59",
    annuityS2: "0",
    k401AnnuityS2: "0",
    iraAnnuityS2: "0",

    years,
    homePayment: "0",
    currentStreetAddress: "",
    currentCityAddress: "",
    currentStateAddress: "",
    currentZipAddress: "",
    firstName: "",
    lastName: "",
    userAgreement: "yes",
    homePayment: "",
    subscriptionPeriod: "5",
    email: "",
    phone: "",

    homePropertyId: 0,
    homeInsurance: "0",
    propertyTax: "0",
    lengthOfLoan: "0",
    mortgageDownPayment: "0",
    mortgageInterestRate: "0",
    targetSavings: "0",
    addlExpenses: "0",
    // do we really want to record boolean values as strings?
    // secondHouse: "no",
    secondHouse: false,
    europeanDataSubject: "",
    schoolDistrict: "",
  };
}

export default function decisionsReducer(state = { ...initState }, action) {
  if (action === undefined) {
    return state;
  }
  const nowYear = now.getFullYear();
  const newState = { ...state };

  switch (action.type) {
    case START_OVER:
      return { ...initState };
    case FETCH_PROFILE:
      console.log("User Profile: ", action.payload);
      let tempSecond;
      if (action.payload.SecondHouse === "S") {
        tempSecond = true;
      } else {
        tempSecond = false;
      }
      return {
        ...newState,
        homePropertyId: action.payload.prop_id,
        currentStreetAddress:
          "We do not store this information for your privacy",
        currentCityAddress: action.payload.City,
        currentStateAddress: action.payload.StateCode,
        currentZipAddress: action.payload.zip,
        county: action.payload.GeoCounty,
        homeLat: action.payload.lat,
        homeLng: action.payload.lng,
        homePayment: action.payload.HomePmt,
        homeInsurance: action.payload.HomeInsurance,
        propertyTax: action.payload.PropertyTax,
        targetSavings: action.payload.TargetSavings,
        addlExpenses: action.payload.AddlExpenses,
        secondHouse: tempSecond,
      };
    case FETCH_BASE_PROPERTY:
      return {
        ...newState,
        baseProperty: action.payload[0],
      };
    case UPDATE_FORM:
      newState[action.payload.id] = action.payload.value;
      newState.recordTStamp = new Date();
      break;
    case SET_AGE1:
      let arrOfAges = [];
      // we might need to add some age validation, to make sure people aren't putting in something crazy.
      // here is where we are determining the start of the array of ages
      let ageYear1 = nowYear - Number(state.birthdayS1.split("-")[1]);

      let i;
      let newStartYear;
      let date2 = new Date();

      if (state.ageIndex === 0) {
        for (let i = 0; i < 10; i++) {
          if (parseInt(state.totalIncomeArray[i]) > state.wageArray[i]) {
            newStartYear = i + date2.getFullYear();
            for (i = state.ageIndex; i < 10 + state.ageIndex; i++) {
              arrOfAges.push(i + ageYear1);
            }
            return {
              ...state,
              ageArray: arrOfAges,
              ageS1: ageYear1,
            };
          }
        }

        // 2
      } else {
        // upgrade iterator

        for (i = state.ageIndex; i < 10 + state.ageIndex; i++) {
          arrOfAges.push(i + ageYear1);
        }
        return {
          ...state,
          ageS1: ageYear1,
          ageArray: arrOfAges,
        };
      }
      break;

    case SET_AGE2:
      let arrOfAges2 = [];
      // we might need to add some age validation, to make sure people aren't putting in something crazy.
      // here is where we are determining the start of the array of ages
      const ageYear2 = nowYear - Number(state.birthdayS2.split("-")[1]);
      let inde;

      let newStartYear2;
      let date3 = new Date();

      if (state.marriedAgeIndex === 0) {
        for (let ind = 0; ind < 10; ind++) {
          if (
            parseInt(state.marriedTotalIncomeArray[ind]) >
            state.marriedWageArray[ind]
          ) {
            newStartYear2 = ind + date3.getFullYear();
            for (
              inde = state.marriedAgeIndex;
              inde < 10 + state.marriedAgeIndex;
              inde++
            ) {
              arrOfAges2.push(inde + ageYear2);
            }
            return {
              ...state,
              marriedAgeArray: arrOfAges2,
              ageS2: ageYear2,
            };
          }
        }

        // 2
      } else {
        // upgrade iterator

        for (
          inde = state.marriedAgeIndex;
          inde < 10 + state.marriedAgeIndex;
          inde++
        ) {
          arrOfAges2.push(inde + ageYear2);
        }
        return {
          ...state,
          ageS2: ageYear2,
          marriedAgeArray: arrOfAges2,
        };
      }
      break;
    case SET_TOTALINCOME:
      let newTotIncomeArray = [];
      let newNonInvestmentIncomeArray = [];
      let invIncome = [];

      let tempIncValue;
      let tempValue;

      let wagesArray = [];
      let ssArray = [];
      let pvtArray = [];
      let pubArray = [];

      let wageIndex;

      for (
        wageIndex = state.ageIndex;
        wageIndex < 10 + state.ageIndex;
        wageIndex++
      ) {
        if (
          parseInt(state.ageS1 + wageIndex) <
          parseInt(state.ageWagesStopS1 || 0)
        ) {
          wagesArray.push(state.wagesS1);
        } else {
          wagesArray.push(0);
        }

        if (
          parseInt(state.ageS1 + wageIndex) >= parseInt(state.retireAgeS1 || 0)
        ) {
          ssArray.push(state.socialSecurityS1);
        } else {
          ssArray.push(0);
        }

        if (
          parseInt(state.ageS1 + wageIndex) >=
          parseInt(state.pvtPensionAgeS1 || 0)
        ) {
          pvtArray.push(state.pvtPensionS1);
        } else {
          pvtArray.push(0);
        }

        if (
          parseInt(state.ageS1 + wageIndex) >=
          parseInt(state.pubPensionAgeS1 || 0)
        ) {
          pubArray.push(state.pubPensionS1);
        } else {
          pubArray.push(0);
        }
      }

      let newK401AgeS1 = state.k401AgeS1;
      if (
        Number(state.birthdayS1.split("-")[0]) < 6 &&
        state.k401AgeS1 === "59"
      ) {
        newK401AgeS1 = "60";
      }

      // iterator upgrade needed here
      for (let i = 0; i < 10; i++) {
        if (state.ageArray[i] < parseInt(newK401AgeS1)) {
          invIncome.push(0);
        } else {
          invIncome.push(state.k401S1);
        }

        tempIncValue =
          parseInt(wagesArray[i]) +
          parseInt(ssArray[i]) +
          parseInt(pvtArray[i]) +
          parseInt(pubArray[i]) +
          parseInt(invIncome[i]);
        newTotIncomeArray.push(tempIncValue);

        tempValue =
          parseInt(wagesArray[i]) +
          parseInt(ssArray[i]) +
          parseInt(pvtArray[i]) +
          parseInt(pubArray[i]);
        newNonInvestmentIncomeArray.push(tempValue);
      }

      let date = new Date();

      let startingYear = date.getFullYear();

      let newYears = new Array(10);

      let indexDifference = state.ageIndex;

      // iterator upgrade needed here

      for (let i = indexDifference; i < 10 + indexDifference; i++) {
        if (parseInt(newTotIncomeArray[i]) > parseInt(wagesArray[i])) {
          startingYear = i + startingYear;
          indexDifference = i;
          break;
        }
      }

      for (let idx = 0; idx < years.length; idx++) {
        newYears[idx] = startingYear + idx;
      }

      // that's the index above that I need to attach as the iterator.
      let incomeNeeded = [];
      let stationaryInvestments;

      var annuityIncome = [];
      let budgetDiff;
      let ann;
      let actualInvestmentArray = [];

      for (ann = 0; ann < 10; ann++) {
        // defining some variables
        stationaryInvestments = 0;

        // calculate needed income
        budgetDiff =
          parseInt(state.budgetArray[ann]) - parseInt(newTotIncomeArray[ann]);

        incomeNeeded.push(budgetDiff);

        let tempVarIncome;

        if (
          budgetDiff < 0 &&
          Math.abs(budgetDiff) >= parseInt(invIncome[ann], 10)
        ) {
          annuityIncome.push(parseInt(invIncome[ann]));
          actualInvestmentArray.push(0);
        } else if (
          budgetDiff < 0 &&
          Math.abs(budgetDiff) < parseInt(invIncome[ann], 10)
        ) {
          tempVarIncome = parseInt(invIncome[ann], 10) - Math.abs(budgetDiff);
          annuityIncome.push(tempVarIncome);
          actualInvestmentArray.push(Math.abs(budgetDiff));
        } else if (budgetDiff > 0) {
          annuityIncome.push(0);
          actualInvestmentArray.push(parseInt(invIncome[ann], 10));
        } else if (Math.abs(budgetDiff) > invIncome[ann]) {
          annuityIncome.push(parseInt(invIncome[ann]));
          actualInvestmentArray.push(0);
        } else if (Math.abs(budgetDiff) < invIncome[ann]) {
          annuityIncome.push(parseInt(invIncome[ann]) + budgetDiff);
          tempVarIncome = Math.abs(budgetDiff) - parseInt(invIncome[ann]);
          actualInvestmentArray.push(invIncome[ann] - Math.abs(tempVarIncome));
        }
      }

      let newAgeGroupArrayS1 = [];

      for (let groupIdx = 0; groupIdx < years.length; groupIdx++) {
        if (parseInt(state.ageArray[groupIdx], 10) < 65) {
          newAgeGroupArrayS1.push(64);
        } else {
          newAgeGroupArrayS1.push(65);
        }
      }

      return {
        ...state,
        investmentIncomeArray: invIncome,
        totalIncomeArray: newTotIncomeArray,
        non401IRAArray: newNonInvestmentIncomeArray,
        wageArray: wagesArray,
        ssArray: ssArray,
        pvtArray: pvtArray,
        pubArray: pubArray,
        startingYear: startingYear,
        years: newYears,
        incomeNeededArray: incomeNeeded,
        annuityIncomeArray: annuityIncome,
        ageIndex: indexDifference,
        ageGroupArrayS1: newAgeGroupArrayS1,
        actualInvestmentArray: actualInvestmentArray,
      };
    case SET_MARRIED_INCOME:
      let newMarriedIncomeArray = [];
      let newMarriedNonInvestmentIncomeArray = [];
      let marriedInvIncome = [];

      let tempMarriedIncValue;
      let tempMarriedValue;

      let marriedWagesArray = [];
      let marriedSsArray = [];
      let marriedPvtArray = [];
      let marriedPubArray = [];

      // we might need to add some age validation, to make sure people aren't putting in something crazy.
      // here is where we are determining the start of the array of ages
      const marriedYear1 = nowYear - Number(state.birthdayS2.split("-")[1]);

      let marriedWageIndex;

      // iterator upgrade needed here

      for (
        marriedWageIndex = state.ageIndex;
        marriedWageIndex < 10 + state.ageIndex;
        marriedWageIndex++
      ) {
        if (
          parseInt(state.ageS2 + marriedWageIndex) <
          parseInt(state.ageWagesStopS2 || 0)
        ) {
          marriedWagesArray.push(state.wagesS2);
        } else {
          marriedWagesArray.push(0);
        }

        if (
          parseInt(state.ageS2 + marriedWageIndex) >=
          parseInt(state.retireAgeS2 || 0)
        ) {
          marriedSsArray.push(state.socialSecurityS2);
        } else {
          marriedSsArray.push(0);
        }

        if (
          parseInt(state.ageS2 + marriedWageIndex) >=
          parseInt(state.pvtPensionAgeS2 || 0)
        ) {
          marriedPvtArray.push(state.pvtPensionS2);
        } else {
          marriedPvtArray.push(0);
        }

        if (
          parseInt(state.ageS2 + marriedWageIndex) >=
          parseInt(state.pubPensionAgeS2 || 0)
        ) {
          marriedPubArray.push(state.pubPensionS2);
        } else {
          marriedPubArray.push(0);
        }
      }

      for (let i = 0; i < 10; i++) {
        if (state.ageArray[i] < state.k401AgeS2) {
          marriedInvIncome.push(0);
        } else {
          marriedInvIncome.push(state.k401S2);
        }

        tempMarriedIncValue =
          parseInt(marriedWagesArray[i]) +
          parseInt(marriedSsArray[i]) +
          parseInt(marriedPvtArray[i]) +
          parseInt(marriedPubArray[i]) +
          parseInt(marriedInvIncome[i]);
        newMarriedIncomeArray.push(tempMarriedIncValue);

        tempMarriedValue =
          parseInt(marriedWagesArray[i]) +
          parseInt(marriedSsArray[i]) +
          parseInt(marriedPvtArray[i]) +
          parseInt(marriedPubArray[i]);
        newMarriedNonInvestmentIncomeArray.push(tempMarriedValue);
      }

      let secondDate = new Date();

      let secondStartingYear = secondDate.getFullYear();

      let secondNewYears = new Array(10);

      let secondIndexDifference = state.ageIndex;

      // iterator upgrade needed here

      for (let i = secondIndexDifference; i < 10 + secondIndexDifference; i++) {
        if (
          parseInt(newMarriedIncomeArray[i]) > parseInt(marriedWagesArray[i])
        ) {
          secondStartingYear = i + secondStartingYear;
          secondIndexDifference = i;
          break;
        }
      }

      for (let idx = 0; idx < years.length; idx++) {
        secondNewYears[idx] = secondStartingYear + idx;
      }

      // that's the index above that I need to attach as the iterator.
      let secondIncomeNeeded = [];

      var secondAnnuityIncome = [];
      let secondBudgetDiff;
      let secondAnn;
      let secondStationaryInvestments;
      let secondActualInvestmentArray = [];
      let marriedActualInvestmentArray = [];

      for (secondAnn = 0; secondAnn < 10; secondAnn++) {
        // defining some variables
        secondStationaryInvestments = 0;

        // calculate needed income
        secondBudgetDiff =
          parseInt(state.budgetArray[secondAnn]) -
          parseInt(
            newMarriedIncomeArray[secondAnn] + state.totalIncomeArray[secondAnn]
          );

        secondIncomeNeeded.push(secondBudgetDiff);

        let secondTempInvVar;

        if (
          secondBudgetDiff < 0 &&
          Math.abs(secondBudgetDiff) >=
            parseInt(marriedInvIncome[secondAnn], 10) +
              parseInt(state.investmentIncomeArray[secondAnn], 10)
        ) {
          secondAnnuityIncome.push(
            parseInt(marriedInvIncome[secondAnn], 10) +
              parseInt(state.investmentIncomeArray[secondAnn], 10)
          );
          secondActualInvestmentArray.push(0);
        } else if (
          secondBudgetDiff < 0 &&
          Math.abs(secondBudgetDiff) <
            parseInt(marriedInvIncome[secondAnn], 10) +
              parseInt(state.investmentIncomeArray[secondAnn], 10)
        ) {
          secondTempInvVar =
            parseInt(marriedInvIncome[secondAnn], 10) +
            parseInt(state.investmentIncomeArray[secondAnn], 10) -
            Math.abs(secondBudgetDiff);
          secondAnnuityIncome.push(secondTempInvVar);
          secondActualInvestmentArray.push(Math.abs(secondBudgetDiff));
        } else if (secondBudgetDiff > 0) {
          secondAnnuityIncome.push(0);
          secondActualInvestmentArray.push(
            parseInt(marriedInvIncome[secondAnn], 10) +
              parseInt(state.investmentIncomeArray[secondAnn], 10)
          );
        } else if (Math.abs(secondBudgetDiff) > marriedInvIncome[secondAnn]) {
          secondAnnuityIncome.push(
            parseInt(marriedInvIncome[secondAnn], 10) +
              parseInt(state.investmentIncomeArray[secondAnn], 10)
          );
          secondActualInvestmentArray.push(0);
        } else if (Math.abs(secondBudgetDiff) < marriedInvIncome[secondAnn]) {
          secondAnnuityIncome.push(
            parseInt(marriedInvIncome[secondAnn], 10) +
              parseInt(state.investmentIncomeArray[secondAnn], 10) +
              secondBudgetDiff
          );
          secondTempInvVar =
            Math.abs(secondBudgetDiff) -
            (parseInt(marriedInvIncome[secondAnn], 10) +
              parseInt(state.investmentIncomeArray[secondAnn], 10));
          secondActualInvestmentArray.push(
            marriedInvIncome[secondAnn] - Math.abs(secondTempInvVar)
          );
        }
      }

      let newAgeGroupArrayS2 = [];

      for (let groupIdx = 0; groupIdx < years.length; groupIdx++) {
        if (
          parseInt(state.ageArray[groupIdx], 10) < 65 &&
          parseInt(state.marriedAgeArray[groupIdx], 10) < 65
        ) {
          newAgeGroupArrayS2.push(64);
        } else if (
          parseInt(state.ageArray[groupIdx], 10) < 65 &&
          parseInt(state.marriedAgeArray[groupIdx], 10) >= 65
        ) {
          newAgeGroupArrayS2.push(645);
        } else if (
          parseInt(state.ageArray[groupIdx], 10) >= 65 &&
          parseInt(state.marriedAgeArray[groupIdx], 10) < 65
        ) {
          newAgeGroupArrayS2.push(645);
        } else if (
          parseInt(state.ageArray[groupIdx], 10) >= 65 &&
          parseInt(state.marriedAgeArray[groupIdx], 10) >= 65
        ) {
          newAgeGroupArrayS2.push(65);
        }
      }

      let investCalc;

      years.map((year, i) => {
        console.log("Final Investment: ", secondActualInvestmentArray[i]);
        console.log("S1 investment: ", state.actualInvestmentArray[i]);
        investCalc =
          secondActualInvestmentArray[i] - state.actualInvestmentArray[i];
        marriedActualInvestmentArray.push(investCalc);
      });

      console.log("Married Array: ", marriedActualInvestmentArray);

      return {
        ...state,
        marriedInvestmentIncomeArray: marriedInvIncome,
        marriedTotalIncomeArray: newMarriedIncomeArray,
        marriedNon401IRAArray: newMarriedNonInvestmentIncomeArray,
        marriedWageArray: marriedWagesArray,
        marriedSsArray: marriedSsArray,
        marriedPvtArray: marriedPvtArray,
        marriedPubArray: marriedPubArray,
        // need to more accurate calculate starting year
        startingYear: secondStartingYear,
        years: secondNewYears,

        // I think these are the calculations that need to be broken apart
        marriedIncomeNeededArray: secondIncomeNeeded,
        marriedAnnuityIncomeArray: secondAnnuityIncome,
        ageS2: marriedYear1,
        marriedAgeIndex: secondIndexDifference,
        ageGroupArrayS2: newAgeGroupArrayS2,
        marriedActualInvestmentArray: secondActualInvestmentArray,
      };
    case CALCULATE_NEEDED:
      let doubleAnnuityIncome = [];
      let doubleNonInvestmentIncome = [];
      let doubleTotalIncome = [];
      let doubleWages = [];

      for (let calcIndex = 0; calcIndex < 10; calcIndex++) {
        doubleWages.push(
          parseInt(state.wageArray[calcIndex], 10) +
            parseInt(state.marriedWageArray[calcIndex], 10)
        );
        doubleAnnuityIncome.push(
          parseInt(state.annuityIncomeArray[calcIndex], 10) +
            parseInt(state.marriedAnnuityIncomeArray[calcIndex], 10)
        );
        doubleNonInvestmentIncome.push(
          parseInt(state.non401IRAArray[calcIndex], 10) +
            parseInt(state.marriedNon401IRAArray[calcIndex], 10)
        );
        doubleTotalIncome.push(
          parseInt(state.totalIncomeArray[calcIndex], 10) +
            parseInt(state.marriedTotalIncomeArray[calcIndex], 10)
        );
      }

      // console.log(doubleWages); // lookinto
      return {
        ...state,
        annuityIncomeArray: doubleAnnuityIncome,
        non401IRAArray: doubleNonInvestmentIncome,
        combinedWageArray: doubleWages,
        totalIncomeArray: doubleTotalIncome,
      };
    case TEST_CALCULATOR_DATA:
      let mockCalculatorData = generateMockData();
      return mockCalculatorData;

    case TEST_USER_DATA:
      let mockUserData = generateEmptyMockData();
      return mockUserData;
    case GENERATE_BUDGET:
      let newBudget = [];
      state.years.map((year) => {
        newBudget.push(state.targetTaxableBudgetS1);
      });
      return {
        ...state,
        budgetArray: newBudget,
      };

    case SET_CURRENTPROPERTY:
      const tempProperty = state.properties.filter((property) => {
        return property.Prop_id === action.payload.prop_id;
      });
      if (tempProperty.length !== 0) {
        newState.currentProperty = tempProperty[0];
      } else {
        alert("Property Set Failure");
      }
      break;

    default:
      return state;
  }

  return newState;
}

export function startOver() {
  return {
    type: START_OVER,
  };
}

export function calculateNeeded() {
  return {
    type: CALCULATE_NEEDED,
  };
}

export function generateYears(data) {
  return {
    type: GENERATE_YEARS,
    payload: data,
  };
}

export function generateBudget() {
  return {
    type: GENERATE_BUDGET,
  };
}

export function generateWages() {
  return {
    type: GENERATE_WAGE_ARRAY,
  };
}

export function generateSS() {
  return {
    type: GENERATE_SS_ARRAY,
  };
}

export function generatePublicPension() {
  return {
    type: GENERATE_PUBLIC_ARRAY,
  };
}

export function generatePrivatePension() {
  return {
    type: GENERATE_PVT_ARRAY,
  };
}

export function updateForm(formPayload) {
  return {
    type: UPDATE_FORM,
    payload: formPayload,
  };
}

export function generateShortfall() {
  return {
    type: GENERATE_SHORTFALL,
  };
}

export function testCalculatorData() {
  return {
    type: TEST_CALCULATOR_DATA,
  };
}

export function testUserData() {
  return {
    type: TEST_USER_DATA,
  };
}

export function setBirthday1(payload) {
  return {
    type: SET_BIRTHDAY1,
    payload: payload,
  };
}

export function setBirthday2(payload) {
  return {
    type: SET_BIRTHDAY2,
    payload: payload,
  };
}

export function setAge1() {
  return {
    type: SET_AGE1,
  };
}

export function setAge2() {
  return {
    type: SET_AGE2,
  };
}

export function setTotalIncome() {
  return {
    type: SET_TOTALINCOME,
  };
}

export function setMarriedIncome() {
  return {
    type: SET_MARRIED_INCOME,
  };
}

export function setNon401IraIncome() {
  return {
    type: SET_NON401IRAINCOME,
  };
}

export function setInvestmentIncome() {
  return {
    type: SET_INVESTMENT_INCOME,
  };
}

export function setCurrentProperty(payload) {
  return {
    type: SET_CURRENTPROPERTY,
    payload: payload,
  };
}

export function fetchProfile(payload) {
  return {
    type: FETCH_PROFILE,
    payload: payload,
  };
}

export function fetchBaseProperty(payload) {
  return {
    type: FETCH_BASE_PROPERTY,
    payload: payload,
  };
}
